// Lightweight device/location detection for default country + currency.
// Uses an IP geolocation lookup (no key) with a browser-locale fallback.
const GEO_KEY = 'checkit:geo';

const EURO_COUNTRIES = ['AT', 'BE', 'CY', 'EE', 'FI', 'FR', 'DE', 'GR', 'IE', 'IT',
  'LV', 'LT', 'LU', 'MT', 'NL', 'PT', 'SK', 'SI', 'ES', 'HR'];
const COUNTRY_CCY = { NG: 'NGN', GH: 'GHS', KE: 'KES', ZA: 'ZAR', GB: 'GBP', US: 'USD' };

export function countryToCurrency(code) {
  if (!code) return 'USD';
  const c = String(code).toUpperCase();
  if (COUNTRY_CCY[c]) return COUNTRY_CCY[c];
  if (EURO_COUNTRIES.includes(c)) return 'EUR';
  return 'USD';
}

function localeFallback() {
  try {
    const loc = (navigator.languages && navigator.languages[0]) || navigator.language || '';
    const m = loc.match(/[-_]([A-Za-z]{2})$/);
    const code = m ? m[1].toUpperCase() : '';
    return code ? { code, name: '', currency: countryToCurrency(code) } : null;
  } catch {
    return null;
  }
}

let _cache = null;

export function getCachedGeo() {
  if (_cache) return _cache;
  try {
    const raw = localStorage.getItem(GEO_KEY);
    if (raw) { _cache = JSON.parse(raw); return _cache; }
  } catch { /* ignore */ }
  return null;
}

// Resolve the device's ISO-2 country code (cached first, then live detect).
export async function getCountryCode() {
  const cached = getCachedGeo();
  if (cached && cached.code) return cached.code;
  const g = await detectGeo();
  return (g && g.code) || '';
}

export async function detectGeo() {
  const cached = getCachedGeo();
  if (cached) return cached;
  let geo = null;
  try {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), 4000);
    const r = await fetch('https://ipapi.co/json/', { signal: ctrl.signal });
    clearTimeout(t);
    if (r.ok) {
      const d = await r.json();
      if (d && d.country_code) {
        geo = { code: d.country_code, name: d.country_name || '', currency: countryToCurrency(d.country_code) };
      }
    }
  } catch { /* network/abort — fall through */ }
  if (!geo) geo = localeFallback();
  geo = geo || { code: '', name: '', currency: 'USD' };
  try { localStorage.setItem(GEO_KEY, JSON.stringify(geo)); } catch { /* ignore */ }
  _cache = geo;
  return geo;
}
